import { render, staticRenderFns } from "./SubjectiveAnamnesa.vue?vue&type=template&id=9fb432e0&scoped=true&"
import script from "./SubjectiveAnamnesa.vue?vue&type=script&lang=js&"
export * from "./SubjectiveAnamnesa.vue?vue&type=script&lang=js&"
import style0 from "./SubjectiveAnamnesa.vue?vue&type=style&index=0&id=9fb432e0&scoped=true&lang=css&"
import style1 from "./SubjectiveAnamnesa.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb432e0",
  null
  
)

export default component.exports